import ConfigureStandard from "../pages/Configure/ConfigureStandard"
import CookiesPolicy from "../pages/CookiesPolicy"
import Home from "../pages/Home"
import HomeConfigure from "../pages/HomeConfigure"
import PrivacyPolicy from "../pages/PrivacyPolicy"
import Summary from "../pages/Summary/Summary"
import TermsOfUse from "../pages/TermsOfUse"

const routes = [
  {
    id: "home",
    path: "",
    index: true,
    component: <Home />,
    layout: "general",
  },
  {
    id: "homeconfigurator",
    path: "configure",
    index: false,
    component: <HomeConfigure />,
    layout: "general",
  },
  {
    id: "configure",
    path: "configure/:MODELO",
    index: false,
    component: <ConfigureStandard />,
    layout: "configurator",
  },
  {
    id: "summary",
    path: "configure/:MODELO/summary",
    index: false,
    component: <Summary />,
    layout: "general",
  },
  {
    id: "terms-of-use",
    path: "terms-of-use",
    index: false,
    component: <TermsOfUse />,
    layout: "general",
  },
  {
    id: "privacy-policy",
    path: "privacy-policy",
    index: false,
    component: <PrivacyPolicy />,
    layout: "general",
  },
  {
    id: "cookies-policy",
    path: "cookies-policy",
    index: false,
    component: <CookiesPolicy />,
    layout: "general",
  },
]

export default routes
